import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  ListItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import Rules from 'src/Rules.json'

// const useStyles = makeStyles(theme => ({
//   item: {
//    display: 'flex',
//     alignItems: 'center',
//     paddingTop: 0,
//     paddingBottom: 0,
//   },
//   itemLeaf: {
//      display: 'flex',
//     alignItems: 'center',
//     paddingTop: 0,
//     paddingBottom: 0
//   },
//   button: {
//     color: theme.palette.text.secondary,
//     padding: '6px 6px',
//     justifyContent: 'flex-start',
//     textTransform: 'none',
//     letterSpacing: 0,
//     width: '100%',
//      textAlign: 'center'
//   },
//   buttonLeaf: {
//     color: theme.palette.text.secondary,
//     padding: '6px 6px',
//     justifyContent: 'flex-start',
//     textTransform: 'none',
//     letterSpacing: 0,
//     width: '100%',
//     fontWeight: theme.typography.fontWeightRegular,
//     '&:hover': {
//       backgroundColor:Rules.nav_top_bar.navbar_items_hover_color
//     },
//     '&.depth-0': {
//       '& $title': {
//         // fontWeight: theme.typography.fontWeightMedium
//       }
//     }
//   },
//   icon: {
//     display: 'flex',
//     alignItems: 'center',
//     marginRight: theme.spacing(3)
//   },
//   title: {
//     marginRight: 'auto'
//   },
//   active: {
//     color: theme.palette.secondary.main,
//     '& $title': {
//       // fontWeight: theme.typography.fontWeightMedium
//     },
//     '& $icon': {
//       color: theme.palette.secondary.main
//     },
//     backgroundColor:Rules.nav_top_bar.navbar_items_hover_color
//   }
// }));

const useStyles = makeStyles(theme => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '8px 8px',
    justifyContent: 'center',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    textAlign: 'center'
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
   
    //borderTopWidth:2,
    //padding: '8px 8px',
    display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
   padding: '12px 0',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      '& $title': {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    '&:hover': {
      backgroundColor:Rules.nav_top_bar.navbar_button_hover
    },
    // textAlign: 'left'
    textAlign: 'center',
    display: 'flex', // add display flex to the button
    alignItems: 'center' // align items to center
  },
  root2: {
 
    width: '100%',
    //height: 2,
    backgroundColor: theme.palette.text.secondary,
    marginTop: 0,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 25
    // marginRight: theme.spacing(1)
  },
  title: {
    marginRight: 'auto',
    whiteSpace: 'nowrap',
    //fontSize: 5
  },
  active: {
    color: theme.palette.secondary.main,
    //borderTop: `2px solid ${theme.palette.secondary.main}` ,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.primary.main,
      fontWeight: 'bold', 
      fontSize: 25 
    },
    backgroundColor: Rules.nav_top_bar.navbar_button_hover,
    // borderRadius: 5
    height:'100%'
  },
 caption: {
  fontSize: 11,
  fontWeight: 400,
  textAlign: 'center',
  lineHeight: 1.2,
},
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: NavIcon,
  info: Info,
  open: openProp,
  navOpen,
  title,  handleDrawer,

  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
    <>
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {NavIcon && (
            <Icon
              icon={NavIcon}
              style={{
                color:Rules.nav_top_bar.navbar_background_color,                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px'
              }}
            />
          )}
          <Typography variant="body2" style={{ color: Rules.nav_top_bar.navbar_background_color}} className={classes.title} sx={{ opacity: navOpen ? 1 : 0 }}>
            {title}
          </Typography>
          {open ? (
            <Icon
              icon="material-symbols-light:expand-less-rounded"
              style={{
                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px',
                color:Rules.nav_top_bar.navbar_background_color
              }}
            />
          ) : (
            <Icon
              icon="material-symbols-light:expand-more-rounded"
              style={{
                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px',
                color: Rules.nav_top_bar.navbar_background_color
              }}
            />
          )}
        </Button>

        <Collapse in={open}>{children}</Collapse>
      </ListItem>
      <Box mt={0.2}/>
</>
    );
  }

  return (
    <>
   <Box display="flex" flexDirection="column" alignItems="center"  textAlign="center">

      
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        // exact
        // style={style}
        to={href}
        fullHeight
        elevation={10}
      >
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" width="100%">
  {Icon && (
    <Icon
      icon={NavIcon}
      style={{
        color: Rules.nav_top_bar.navbar_background_color,
        fontSize: '28px',
        marginBottom: '4px'
      }}
    />
  )}
  <Typography
    variant="caption"
    className={classes.caption}
    style={{
      color: Rules.nav_top_bar.navbar_background_color,
      //opacity: navOpen ? 1 : 0,
    }}
  >
    {title}
  </Typography>
</Box>

      </Button>
    </Box>
    {/* <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        style={style}
        to={href}
      >
        {NavIcon && (
          <Icon
            icon={NavIcon}
            style={{
              color:'#ffffff',              fontSize: '25px',
              marginRight: '10px',
              marginBottom: '2px'
            }}
          />
        )}
        <Typography variant="body2" style={{ color: '#ffffff' }} className={classes.title} sx={{ opacity: navOpen ? 1 : 0 }}>
          {title}
        </Typography>
        {Info && <Info />}
      </Button>
    </ListItem>
    <Box mt={0.3}/> */}
</>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};
NavItem.defaultProps = {
  open: false
};

export default NavItem;